module.exports = __webpack_public_path__ + "img/fauteuil-15.05afdd5d.jpg";